export default __webpack_public_path__ + "static/media/kik.945f4cb1.svg";